// extracted by mini-css-extract-plugin
export default {"wrapper":"ErrorFallback_wrapper__FI2Ef","wrapper__content":"ErrorFallback_wrapper__content__DoAjo"};